import { jsx as e } from "react/jsx-runtime";
import { useMultiStyleConfig as n, chakra as r } from "@chakra-ui/react";
const l = ({
  errorMessage: s = "We've encountered an error. Please reload and try again."
}) => {
  const { errorMessage: o, errorMessageContainer: a } = n("FileUploader");
  return /* @__PURE__ */ e(r.div, { __css: a, children: /* @__PURE__ */ e(r.div, { __css: o, children: s }) });
};
export {
  l as ErrorMessage
};
//# sourceMappingURL=ErrorMessage.es.js.map
